var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"language"},[_c('span',{class:['language-text js-language-text', _vm.$i18n.locale === _vm.code ? 'select' : ''],on:{"click":function($event){return _vm.setLocale(_vm.code)}}},[_vm._v(_vm._s(_vm.name))])])
}
var staticRenderFns = []

export { render, staticRenderFns }